import { combineReducers, configureStore } from '@reduxjs/toolkit';

import { ellipsisApi } from './ellipsisApi';
import authSlice from './reducers/authSlice';
import booking from './reducers/bookingReducer';
import chatSlice from './reducers/chatSlice';
import content from './reducers/contentReducer';
import currency from './reducers/currencyReducer';
import routerSlice from './reducers/routerReducer';
import ui from './reducers/uiReducer';

// Single source of truth for the state shape
const rootReducer = combineReducers({
  router: routerSlice.reducer,
  auth: authSlice.reducer,
  booking: booking.reducer,
  currency: currency.reducer,
  chat: chatSlice.reducer,
  content: content.reducer,
  ui: ui.reducer,
  [ellipsisApi.reducerPath]: ellipsisApi.reducer,
});

// Derive RootState from the reducer, not from the store instance
export type RootState = ReturnType<typeof rootReducer>;

// Factory to create a per-request store (SSR) or a fresh client store
export const makeStore = (preloadedState?: Partial<RootState>) =>
  configureStore({
    reducer: rootReducer,
    preloadedState,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        thunk: {
          extraArgument: ellipsisApi,
        },
        immutableCheck: false,
        serializableCheck: false,
      }).concat(ellipsisApi.middleware),
  });

// Backwards-compatible singleton store for SPA-only routes/usages
const store = makeStore();

export type AppStore = ReturnType<typeof makeStore>;
export type AppDispatch = AppStore['dispatch'];
export default store;
